import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  categoryList: [],
  selectCategory: "",
};

const CategoryReducer = createSlice({
  name: "CategoryReducer",
  initialState: initialState,
  reducers: {
    setCategoryList: (state, { payload }) => {
      return {
        ...state,
        categoryList: payload,
      };
    },
    setCategory: (state, { payload }) => {
      return {
        ...state,
        selectCategory: payload,
      };
    },

    updateCategory: (state, { payload }) => {
      console.log("payload", payload);

      let newList = [...state.categoryList];
      console.log("newList", newList);
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].category_id === payload.category_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        categoryList: newList,
      };
    },
    addList: (state, { payload }) => {
      console.log("payload", payload);
      let newList = [...state.categoryList];
      newList.push(payload);
      return {
        ...state,
        categoryList: newList,
      };
    },
  },
});

export default CategoryReducer;
